import { AvailableOperationStatus } from "../operations/available-operation-status";
import { AvailableOperationTypes } from "../operations/available-operation-types";
import { OperationRequest } from "../operations/operation-request";
import { Routes } from "../routes";
import { Strategy } from "./abstract-strategy";

export class DocumentStrat extends Strategy {

    public hasCondition(request: OperationRequest): boolean {
        const availableStatus = [
            AvailableOperationStatus.ACTIVA,
            AvailableOperationStatus.PENDIENTE_ENTREGA,
            AvailableOperationStatus.NO_ENTREGADO
        ];
        const notAvailableOperations = [
            AvailableOperationTypes.NOTE
        ]
        const isOperationNOTE = notAvailableOperations.includes(request.operationType);
        const hasActiveStatus = availableStatus.includes(request.state);
        const hasDocument = !!(request.idOperation && (request.idDocument || request.documentList?.length > 1));
        if (hasActiveStatus && hasDocument && !isOperationNOTE) {
            return true;
        }
        return false;
    }

    public setStrategy(request?: OperationRequest): void {
        const documents = request?.documentList?.filter((doc) => doc.type === 1)[0];
        const route = request.documentList?.length > 1 ? documents.idDocument : request.idDocument;
        this.pathToGo = `${Routes.DOCUMENT}/${route}`;
    }
}
